<template>
  <v-container grid-list-md>
    <v-flex>
      <v-card>
        <v-card-title>
          <h1>Admins List</h1>
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                append-icon="search"
                label="Search by Username"
                v-model="search.filterByName"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 offset-xs1>
              <v-text-field
                append-icon="search"
                label="Search by Email"
                v-model="search.filterByEmail"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 offset-xs1 v-if="getIsSuperUser">
              <v-btn color="orange darken-2" @click.native="logoutAdmins('')">Logout all users</v-btn>
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="headers"
            :items="list"
            :pagination.sync="pagination"
            :total-items="totalItemsToNumbers"
            class="elevation-1"
          >
            <!--:search="search"-->
            <template slot="items" slot-scope="props">
              <td>{{ props.item.userName }}</td>
              <td>{{ props.item.email }}</td>
              <td>
                <v-chip v-for="scope in props.item.scopes" :key="`scope-${scope}`">
                  {{ scope }}
                </v-chip>
              </td>
              <td v-if="getIsSuperUser">
                <v-icon
                  size="18"
                  :color="props.item.isOnline ? 'green' : 'red'"
                >fiber_manual_record
                </v-icon>
                {{ props.item.isOnline ? 'online' : 'offline' }}
              </td>
              <td v-if="getIsSuperUser">
                <v-btn
                  v-if="props.item.isOnline"
                  color="orange darken-2"
                  class="mx-0"
                  fab flat
                  @click.stop="logoutAdmins(props.item.id)"
                >
                  <v-icon
                  >input
                  </v-icon>
                </v-btn>
              </td>
              <td class="justify-center">
                <v-btn color="lime"
                       class="mx-0"
                       fab flat
                       :disabled="!isWriteAvailable"
                       @click.stop="editItem(props.item)"
                >
                  <v-icon>create</v-icon>
                </v-btn>
              </td>
              <td class="justify-center">
                <v-btn
                  class="mx-0"
                  color="error"
                  fab flat
                  :disabled="!isWriteAvailable"
                  @click="openModalDelete(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
            <template slot="pageText" slot-scope="{}">
              Page {{pagination.page}} of {{getUsers.totalPages}}
            </template>
            <v-alert outline color="grey lighten-2" slot="no-results" :value="true" icon="warning">
              No data
            </v-alert>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog persistent v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Change scope of {{editedItem.email}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>
                <v-radio-group
                  v-model="checkedScopes"
                  :error="!!$v.checkedScopes"
                >
                  <v-radio
                    v-for="item in userScopes"
                    :key="item"
                    :label="`${item}`"
                    :value="`${item}RoleScope`"
                    >
                  </v-radio>
                </v-radio-group>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogDeleteUser" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Are you sure you want to delete {{editedItem.email}}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="deleteItem(editedItem)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { clone, path } from 'ramda'
  import stringCapitalize from '@/utils/helpers'
  import { required } from 'vuelidate/lib/validators'
  import ECheckboxes from 'shared/ECheckboxes'
  import mixins from '@/utils/mixins'
  import roleScopes from '@/utils/roleScopes'

  export default {
    name: "Users",
    mixins: [mixins.isWriteAvailable],
    components: {
      ECheckboxes
    },
    props: {
      userScopes: {
        type: Array
      }
    },
    data () {
      return {
        search: {
          filterByName: '',
          filterByEmail: ''
        },
        page: 0,
        itemsOnPage: 10,
        checkedScopes: [],
        dialog: false,
        loading: true,
        dialogDeleteUser: false,
        pagination: {
          rowsPerPage: 10
        },
        list: [],
        headersForMaster: [
          { text: 'Username', value: 'userName', sortable: false },
          { text: 'Email', value: 'email', sortable: false },
          { text: 'Scopes', value: 'scopes', sortable: false },
          { text: 'Edit', value: 'edit', sortable: false },
          { text: 'Delete', value: 'delete', sortable: false }
        ],
        headersForSuperAdmin: [
          { text: 'Username', value: 'userName', sortable: false },
          { text: 'Email', value: 'email', sortable: false },
          { text: 'Scopes', value: 'scopes', sortable: false },
          { text: 'Online status', value: 'isOnline', sortable: false },
          { text: 'Logout', value: 'logout', sortable: false },
          { text: 'Edit', value: 'edit', sortable: false },
          { text: 'Delete', value: 'delete', sortable: false }
        ],
        editedIndex: -1,
        editedItem: {},
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'master'
      }
    },
    computed: {
      ...mapGetters([
        'getUsers',
        'getScopesList',
        'getTotalUserItems',
        'getIsSuperUser',
        'getIsMaster'
      ]),
      headers () {
        return this.getIsSuperUser ? this.headersForSuperAdmin : this.headersForMaster
      },
      totalItemsToNumbers () {
        return parseInt(this.getTotalUserItems) || 0
      }
    },
    watch: {
      search: {
        handler (newVal) {
          let config = {page: this.page, itemsOnPage: this.itemsOnPage,userName: path(['filterByName'], newVal), email: path(['filterByEmail'], newVal)}
          this.$emit('handlePaginationChange', config)
          this.fetchUsersToTable()
        },
        deep: true
      },
      pagination: {
        handler (newVal, oldVal) {
          if (!this.isPaginationChanged(newVal, oldVal)) return
          const { page, rowsPerPage } = this.pagination
          this.page = page - 1 || 0
          this.itemsOnPage = rowsPerPage || 10
          if (rowsPerPage === -1) this.itemsOnPage = this.getTotalUserItems
          let config = {page: this.page, itemsOnPage: this.itemsOnPage,userName: path(['filterByName'], this.search), email: path(['filterByEmail'], this.search)}
          this.$emit('handlePaginationChange', config)
          this.fetchUsersToTable()
        },
        deep: true
      },
      getUsers: {
        handler () {
          this.list = clone(this.getUsers.list)
        },
        deep: true
      },
    },
    validations: {
      checkedScopes: {
        required
      }
    },
    methods: {
      ...mapActions([
        'deleteUser',
        'deleteUserBySuperAdmin',
        'updateUser',
        'updateUserBySuperAdmin',
        'fetchScopesList',
        'fetchUsers',
        'logoutSingleAdmin',
        'logoutAllAdmins'
      ]),
      checkboxes(el){
        this.checkedScopes = el
      },
      stringCapitalize,
      async fetchUsersToTable () {
        this.loading = true
        this.$emit('fetchUsersToTable')
      },
      editItem (item) {
        this.editedIndex = this.list.indexOf(item)
        this.editedItem = { ...item }
        this.dialog = true
        this.checkedScopes = [...this.editedItem.scopes]
      },
      async openModalDelete (user) {
        this.dialogDeleteUser = true
        this.editedItem = { ...user }
      },
      async deleteItem (user) {
        this.dialogDeleteUser = false
        this.getIsSuperUser
          ? await this.deleteUserBySuperAdmin(user.id)
          : await this.deleteUser(user.id)
        this.editedItem = {}
        this.fetchUsersToTable()
      },
      close () {
        this.dialog = false
        this.dialogDeleteUser = false
        this.editedItem = {}
        this.editedIndex = -1
      },
      async save () {
        this.$v.$touch()
        if (this.$v.$error) {
          return
        } else if (!this.$v.$error && this.editedIndex > -1) {
          let config = {
            id: this.editedItem.id,
            scopes: roleScopes[this.checkedScopes]
          }
          this.getIsSuperUser
            ? await this.updateUserBySuperAdmin(config)
            : await this.updateUser(config)
          this.fetchUsersToTable()
        }
        this.close()
      },
      isPaginationChanged (newVal, oldVal) {
        return newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage
      },
      async logoutAdmins(id) {
        id ? await this.logoutSingleAdmin({userIds: [id]}) : await this.logoutAllAdmins()
        await this.fetchUsersToTable()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Users/usersTable.vue